import { render, staticRenderFns } from "./Insumo_Produccion.vue?vue&type=template&id=57837a2e&"
import script from "./Insumo_Produccion.vue?vue&type=script&lang=js&"
export * from "./Insumo_Produccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports